import React from "react";
import { useNavigate } from "react-router-dom";
import { sendSlackMessage } from "../../models/notifications";
import { PartnersImage } from "../../assets/assets";

export default function HeroSection() {
  const navigate = useNavigate();

  const handleBecome = () => {
    sendSlackMessage("Someone clicked on the join partnerships from the partnerships page.", "#website-updates");
    navigate("/partners/join");
  };

  return (
    <section style={{ background: "#faf2eb", padding: "72px 24px 80px" }}>
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "56px",
          flexWrap: "wrap",
        }}
        className="flex-col-mobile"
      >
        {/* Text */}
        <div style={{ flex: "1 1 340px", minWidth: 0 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "7px",
              background: "rgba(22,163,74,0.08)",
              border: "1px solid rgba(22,163,74,0.25)",
              borderRadius: "99px",
              padding: "5px 14px",
              marginBottom: "24px",
            }}
          >
            <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#16a34a", flexShrink: 0 }} />
            <span style={{ fontSize: "0.8125rem", fontWeight: 600, color: "#16a34a", letterSpacing: "0.01em" }}>
              Partner ecosystem
            </span>
          </div>

          <h1
            style={{
              fontSize: "clamp(2rem, 5vw, 3.25rem)",
              fontWeight: 800,
              lineHeight: 1.1,
              letterSpacing: "-0.03em",
              color: "#0f0f10",
              marginBottom: "20px",
            }}
          >
            Premier Suite{" "}
            <span style={{ color: "#16a34a" }}>Quality</span>
          </h1>

          <p
            style={{
              fontSize: "1.0625rem",
              color: "#6b7280",
              lineHeight: 1.7,
              maxWidth: "520px",
              marginBottom: "36px",
            }}
          >
            As your business grows, you face new challenges. Whether you're starting a new sales channel,
            evolving your tech stack, or re-platforming — these apps offer a wide range of commerce integration
            possibilities with a high level of creative control.
          </p>

          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <a
              href="#partners"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "13px 28px",
                borderRadius: "99px",
                background: "#16a34a",
                color: "#fff",
                fontSize: "0.9375rem",
                fontWeight: 700,
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              Explore partners
            </a>

            <button
              type="button"
              onClick={handleBecome}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "13px 28px",
                borderRadius: "99px",
                background: "transparent",
                color: "#374151",
                fontSize: "0.9375rem",
                fontWeight: 600,
                border: "1px solid rgba(0,0,0,0.12)",
                cursor: "pointer",
                fontFamily: "inherit",
                whiteSpace: "nowrap",
              }}
            >
              Become a partner
            </button>
          </div>
        </div>

        {/* Image */}
        <div style={{ flex: "1 1 340px", minWidth: 0 }}>
          <img
            src={PartnersImage}
            alt="Pabloo Partnerships"
            loading="lazy"
            style={{
              width: "100%",
              borderRadius: "16px",
              display: "block",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .flex-col-mobile {
            flex-direction: column !important;
          }
        }
      `}</style>
    </section>
  );
}
